import React, { forwardRef } from 'react';
import FormField from './FormField';

function buildInputClassName({ error, muted, className = '' }) {
    return ['input', muted ? 'input-muted' : '', error ? 'input-error' : '', className]
        .filter(Boolean)
        .join(' ');
}

const TextInput = forwardRef(function TextInput(
    {
        label,
        name,
        id,
        error,
        helper,
        note,
        required = false,
        muted = false,
        className = '',
        fieldClassName = '',
        ...props
    },
    ref,
) {
    const inputId = id || (name ? `input-${name}` : undefined);
    const input = (
        <input
            ref={ref}
            id={inputId}
            name={name}
            required={required}
            className={buildInputClassName({ error, muted, className })}
            {...props}
        />
    );

    if (!label && !error && !helper && !note) {
        return input;
    }

    return (
        <FormField
            label={label}
            htmlFor={inputId}
            required={required}
            error={error}
            helper={helper}
            note={note}
            className={fieldClassName}
        >
            {input}
        </FormField>
    );
});

export default TextInput;
